import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      step: 1,
      title: "Provide Your Data",
      description: "Simply give us your existing spreadsheets or documents (FAQs, products, services)."
    },
    {
      step: 2,
      title: "We Configure",
      description: "Our team sets up and trains the chatbot specifically for your business needs."
    },
    {
      step: 3,
      title: "Embed & Go Live",
      description: "Add a simple code snippet to your website, and your chatbot is ready!"
    }
  ];

  return (
    <section className="bg-white dark:bg-gray-900 py-12 lg:py-20">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-text-primary dark:text-white mb-12">
          Simple Setup Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((item) => (
            <div key={item.step} className="text-center p-6 border border-gray-200 dark:border-gray-700 rounded-lg">
              <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-primary text-white rounded-full font-bold text-xl">
                {item.step}
              </div>
              <h3 className="text-xl font-semibold text-text-primary dark:text-white mb-2">
                {item.title}
              </h3>
              <p className="text-text-secondary dark:text-gray-400">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 